import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-form-foreword',
  templateUrl: './create-form-foreword.component.html',
  styleUrls: ['./create-form-foreword.component.scss']
})
export class CreateFormForewordComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
